import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  className?: string;
  light?: boolean;
}
export function CountdownTimer({
  className = '',
  light = false
}: CountdownTimerProps) {
  const {
    minutes,
    seconds
  } = useCountdown();
  const baseClasses = 'font-mono font-bold tracking-wider rounded px-2 py-1';
  const colorClasses = light ? 'bg-white text-red-600' : 'bg-red-600 text-white';
  return <div className={`flex items-center space-x-1 ${className}`} data-id="element-49">
      <span className={`${baseClasses} ${colorClasses}`} data-id="element-50">00</span>
      <span className={light ? 'text-white font-bold' : 'text-red-600 font-bold'} data-id="element-51">
        :
      </span>
      <span className={`${baseClasses} ${colorClasses}`} data-id="element-52">{minutes}</span>
      <span className={light ? 'text-white font-bold' : 'text-red-600 font-bold'} data-id="element-53">
        :
      </span>
      <span className={`${baseClasses} ${colorClasses}`} data-id="element-54">{seconds}</span>
    </div>;
}